import PlainInput from 'app/common/ui-next/plain-input'
import PlainLabel from 'app/common/ui-next/plain-label'
import PlainFieldset from 'app/common/ui-next/plain-fieldset'

import { ControlsRow } from './templates/ControlsRow'
import { ControlsRowItem } from './templates/ControlsRowItem'


export const childControls = {
  Name: 'studentName',
  School: 'school',
  Class: 'class',
} as const

type Props = {
  studentName: string
  classTitle: string
  schoolTitle: string
  loading: boolean
}

export const ChildControls = ({ studentName, classTitle, schoolTitle, loading }: Props) => {
  return (
    <PlainFieldset legend="Данные ребенка" strong>
      <ControlsRow>
        <ControlsRowItem width="50%">
          <PlainLabel htmlFor={childControls.Name} displayAsBlock>{'ФИО ребенка'}</PlainLabel>
          <PlainInput
            id={childControls.Name}
            value={studentName}
            loading={loading}
            disabled
            wide
          />
        </ControlsRowItem>

        <ControlsRowItem width="40%">
          <PlainLabel htmlFor={childControls.School} displayAsBlock>{'Заведение'}</PlainLabel>
          <PlainInput
            id={childControls.School}
            value={schoolTitle}
            loading={loading}
            disabled
            wide
          />
        </ControlsRowItem>

        <ControlsRowItem width="10%">
          <PlainLabel htmlFor={childControls.Class} displayAsBlock>{'Класс'}</PlainLabel>
          <PlainInput
            id={childControls.Class}
            value={classTitle}
            loading={loading}
            disabled
            wide
          />
        </ControlsRowItem>
      </ControlsRow>
    </PlainFieldset>
  )
}
